import Udesk from 'Udesk';
import React, { FC, memo } from 'react';
import { Badge, Button, Icon, Space } from 'udesk-ui';
import Ellipsis from 'src/components/common/Ellipsis';

interface TemplateProps {
    complaintInfo: any;
    localesReview: any;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { complaintInfo, localesReview } = props;

    const color =
        complaintInfo.complainStatus === Udesk.enums.complainStatus.success.id
            ? '#0FBA26'
            : complaintInfo.complainStatus === Udesk.enums.complainStatus.fail.id
            ? '#FB5127'
            : 'rgba(0, 0, 0, 0.25)';

    return (
        <>
            <div className="appeal-history-component-detail-item-content">
                <div style={{ display: 'flex', overflow: 'hidden', flex: 1 }}>
                    <div className="appeal-history-component-detail-item-content-label">{`${localesReview.reason}:`}</div>
                </div>
                <Space size={0}>
                    <Badge color={color} />
                    <div>
                        {Udesk.enums.complainStatus.getName(complaintInfo.complainStatus || 1)}
                    </div>
                </Space>
            </div>

            <div style={{ padding: 8, backgroundColor: 'rgba(0, 0, 0, 0.05)', fontSize: 12 }}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        fontWeight: 500,
                    }}
                >
                    <div>
                        {complaintInfo.complainCustomerName ? (
                            <Space size={0}>
                                <Badge status="default" />
                                <Ellipsis
                                    text={complaintInfo.complainCustomerName}
                                    style={{ width: 100 }}
                                />
                            </Space>
                        ) : null}
                    </div>

                    <div>{complaintInfo.complainTime ?? ''}</div>
                </div>

                <div style={{ color: 'rgba(0, 0, 0, 0.45)' }}>{complaintInfo.complaint}</div>

                <div>
                    {complaintInfo.attachments && complaintInfo.attachments.length > 0
                        ? complaintInfo.attachments.map((f) => {
                              return (
                                  <div>
                                      <Button
                                          style={{ padding: 0, width: '100%' }}
                                          size="small"
                                          type="link"
                                          icon={<Icon type="PaperClipOutlined" antdIcon={true} />}
                                          href={f.url}
                                          target="_blank"
                                      >
                                          <Ellipsis
                                              style={{
                                                  width: 'calc(100% - 24px)',
                                                  color: '#1b6dff',
                                                  fontSize: 12,
                                              }}
                                              text={f.name}
                                          />
                                      </Button>
                                  </div>
                              );
                          })
                        : null}
                </div>
            </div>
        </>
    );
});

export default Template;
